export default {
  strict: true,
  namespaced: true,
  state: {
    package: null
  },
  mutations: {
    setPackage (state, value) { state.package = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/package-details/index.js